<template>
  <div class='legend-widget-cell'>
    <div class='legend-section'>
      <span class="material-icons" :style="{'color': color}">
        fiber_manual_record
      </span>
      <span class='label'>
        {{ label }}
      </span>
      <div class='value-section'>
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InlineLegendWidgetCell',
  props: {
    value: {
      required: true,
      type: Number,
    },
    color: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.legend-widget-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: rem(5);
  margin-right: $space-2;
  .legend-section {
    display: flex;
    align-items: center;
    .label {
      margin-left: rem(5);
      color: var(--text-secondary);
      text-transform: uppercase;
      font-family: $font-family-regular;
      font-size: $font-size-xs;
      letter-spacing: rem(1.1);
      line-height: rem(12);
    }
  }
  .value-section {
    margin-left: $space-2;
    font-family: $font-family-semibold;
    font-size: $font-size-sm;
    font-weight: bold;
    letter-spacing: 0;
    line-height: $space-4;
  }
}
</style>
